(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6028],{

/***/ 32144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







function TabListNew(_ref) {
  var data = _ref.data,
      activeTab = _ref.activeTab,
      tabLinks = _ref.tabLinks,
      tabListClass = _ref.tabListClass,
      tabClass = _ref.tabClass,
      children = _ref.children,
      _onChange = _ref.onChange;
  var tabListStyle = ["rounded-full", tabListClass.display || "flex justify-start lg:justify-center", tabListClass.length || " w-fit mx-auto", tabListClass.background || "bg-transparent", tabListClass.padding || "p-0", tabListClass.border || "border md:border border-bbc-neutral-600", tabListClass.othersClass].join(" ");
  var tabStyle = ["relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center", tabClass.width || "w-fit", tabClass.textSize || "text-sm leading-6", tabClass.textFontWeight || "font-semibold", tabClass.padding || "py-3 px-6", tabClass.margin || "", tabClass.othersClass].join(" ");
  /* Handle Event */

  var handleOnClickTabLink = function handleOnClickTabLink(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "w-full",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
      defaultIndex: activeTab || 0,
      onChange: function onChange() {
        return _onChange && _onChange();
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.List */ .OK.List, {
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabListStyle),
        children: Object.keys(data).length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
            className: function className(_ref2) {
              var selected = _ref2.selected;
              return (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabStyle, selected ? "".concat(tabClass.tabColorActive || "border-bbc-brand-500 text-bbc-brand-500") : " ".concat(tabClass.tabColor || "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500", " "));
            },
            as: "div",
            children: [item.title || item, Array.isArray(tabLinks) && (tabLinks === null || tabLinks === void 0 ? void 0 : tabLinks.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
              "data-go": "#".concat(tabLinks[index]),
              onClick: handleOnClickTabLink,
              className: "absolute inset-0 h-full w-full"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})]
          }, item.id || item);
        })
      }), children]
    })
  });
}

TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TabListNew);

/***/ }),

/***/ 81601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var ContactUs = function ContactUs(_ref) {
  var isPaymentGuideline = _ref.isPaymentGuideline,
      isRefundPolicy = _ref.isRefundPolicy;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_1__/* .LayoutContext */ .VY),
      locationRouter = _useContext.locationRouter;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("section", {
      id: "contact-us",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          text: "Contact Us",
          className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800"
        }), isRefundPolicy ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mb-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            className: "mb-4",
            children: "Should you have any queries regarding service quality and refund requests, please email us via: compliance@bbcincorp.com. We will do our best to support you with your queries."
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            children: "You can also contact us at the following address:"
          })]
        }) : locationRouter !== "sg" && locationRouter !== "hk" && !isPaymentGuideline && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "mb-6 lg:mb-10",
          children: "If you have any questions about this Agreement, please contact us by email or regular mail at the following address:"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "".concat(locationRouter === "sg" || locationRouter === "hk" ? "lg:grid-cols-1" : "lg:grid-cols-2", "  grid gap-y-6 lg:gap-x-[30px] lg:gap-y-0"),
          children: [locationRouter !== "sg" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              text: "BBCIncorp Limited in Hong Kong",
              className: "text-2xl font-semibold leading-9 text-bbc-brand-700"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
              children: ["Registered No: 2508698", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "D-U-N-S Number 664611652."]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex auto-rows-auto items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/location-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "https://goo.gl/maps/adod2kPo4Ht2GXXH9",
                rel: "nofollow noreferrer",
                target: "_blank",
                children: "Room 9, 4F, Beverley Commercial Centre, 87-105 Chatham Road South, Tsim Sha Tsui, Kowloon, Hong Kong"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/earth-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "mailto:service@bbcincorp.com",
                rel: "nofollow",
                children: "service@bbcincorp.com"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/phone-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "tel:+85281928666",
                rel: "nofollow",
                children: "(+852) 8192 8666"
              })]
            })]
          }), locationRouter !== "hk" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              text: "BBCIncorp Pte. Ltd. in Singapore",
              className: "text-2xl font-semibold leading-9 text-bbc-brand-700"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: "".concat(locationRouter === "sg" || locationRouter === "hk" ? "hidden" : "hidden lg:block")
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/location-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "68 Circular Road, #02-01 Singapore (049422), Singapore"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/earth-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "mailto:service@bbcincorp.com",
                rel: "nofollow",
                children: "service@bbcincorp.com"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "flex items-center gap-x-2.5",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/assets/icons/phone-white.svg",
                width: 48,
                height: 48,
                wrapper: {
                  className: "flex-none w-12"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                className: "block hover:text-bbc-brand-600",
                href: "tel:+6531381666",
                rel: "nofollow",
                children: "(+65) 3138 1666"
              })]
            })]
          })]
        })]
      })
    })
  });
};

ContactUs.defaultProps = {
  isPaymentGuideline: false,
  isRefundPolicy: false
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactUs);

/***/ }),

/***/ 40437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ legal_documents; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/ContactUs/index.js
var ContactUs = __webpack_require__(81601);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/legal-documents/ContactUsPrivacyPolicy/index.js






var ContactUsPrivacyPolicy = function ContactUsPrivacyPolicy(_ref) {
  var dataContactUs = _ref.dataContactUs;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "contact-us",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Contact Us",
          className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800"
        }), dataContactUs.description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-10",
          children: dataContactUs.description
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: dataContactUs.companyName,
            className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-700"
          }), dataContactUs.registered && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-4",
            children: ["Registered No: ", dataContactUs.registered, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "D-U-N-S Number ", dataContactUs.duns, "."]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-4 flex items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/location-white.svg",
              width: 48,
              height: 48,
              wrapper: {
                className: "flex-none w-12 mr-3"
              }
            }), dataContactUs.ggMaps ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "block hover:text-bbc-brand-600",
              href: dataContactUs.ggMaps,
              rel: "nofollow noreferrer",
              target: "_blank",
              children: dataContactUs.location
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: dataContactUs.location
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-4 flex items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/earth-white.svg",
              width: 48,
              height: 48,
              wrapper: {
                className: "flex-none w-12 mr-3"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: " hover:text-bbc-brand-600",
                href: "mailto:private@bbcincorp.com",
                rel: "nofollow",
                children: "private@bbcincorp.com"
              }), "\xA0or\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
                className: "inline md:hidden"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: " hover:text-bbc-brand-600",
                href: "mailto:service@bbcincorp.com",
                rel: "nofollow",
                children: "service@bbcincorp.com"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-x-2.5",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/icons/phone-white.svg",
              width: 48,
              height: 48,
              wrapper: {
                className: "flex-none w-12"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "block hover:text-bbc-brand-600",
              href: "tel:".concat(dataContactUs.phoneNumber),
              rel: "nofollow",
              children: dataContactUs.phoneText
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var legal_documents_ContactUsPrivacyPolicy = (ContactUsPrivacyPolicy);
;// CONCATENATED MODULE: ./components/templates/common/legal-documents/index.js












var LegalDocuments = function LegalDocuments(_ref) {
  var _data$banner, _data$banner2, _data$banner3, _data$banner3$image, _data$banner4, _data$banner4$image, _data$banner5, _data$banner5$image, _data$banner6, _data$banner6$image, _data$banner7, _data$banner7$image, _data$dataContent, _data$dataContent2, _data$dataContent3, _data$dataContent4, _data$dataContent5, _data$dataContent6, _data$dataContent7, _data$dataContent8, _data$dataContent9, _data$dataContent10, _data$dataContent11;

  var data = _ref.data;

  var getId = function getId(id) {
    return id.replace(/[^a-zA-Z ]/g, " ").replace(/\s+/g, " ").toLowerCase().split(" ").join("-");
  };

  (0,react.useLayoutEffect)(function () {
    if (window.location.hash) {
      setTimeout(function () {
        var id = window.location.hash.replace("#", "");
        var scrollToTable = document.getElementById(id).getBoundingClientRect();
        window.scrollTo({
          top: scrollToTable.top + window.pageYOffset - 86,
          behavior: "smooth"
        });
      }, 100);
    }
  }, []);

  var scrollToSection = function scrollToSection(event, id) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    var scrollToTable = document.getElementById(id).getBoundingClientRect();
    window.scrollTo({
      top: scrollToTable.top + window.pageYOffset - 86,
      behavior: "smooth"
    });

    if (history.pushState) {
      history.pushState(null, null, "#".concat(id));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-fix-min-h-569",
        title: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.title,
        bgColor: "bg-bbc-terms-policy",
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner2 = data.banner) === null || _data$banner2 === void 0 ? void 0 : _data$banner2.breadcrumbs,
        leftClassName: "relative lg:mt-0 col-12 lg:col-7",
        rightClassName: "col-12 lg:col-5",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: data === null || data === void 0 ? void 0 : (_data$banner3 = data.banner) === null || _data$banner3 === void 0 ? void 0 : (_data$banner3$image = _data$banner3.image) === null || _data$banner3$image === void 0 ? void 0 : _data$banner3$image.src,
          width: data === null || data === void 0 ? void 0 : (_data$banner4 = data.banner) === null || _data$banner4 === void 0 ? void 0 : (_data$banner4$image = _data$banner4.image) === null || _data$banner4$image === void 0 ? void 0 : _data$banner4$image.width,
          height: data === null || data === void 0 ? void 0 : (_data$banner5 = data.banner) === null || _data$banner5 === void 0 ? void 0 : (_data$banner5$image = _data$banner5.image) === null || _data$banner5$image === void 0 ? void 0 : _data$banner5$image.height,
          wrapper: {
            className: "".concat(data !== null && data !== void 0 && (_data$banner6 = data.banner) !== null && _data$banner6 !== void 0 && (_data$banner6$image = _data$banner6.image) !== null && _data$banner6$image !== void 0 && _data$banner6$image.classNameWrapper ? data === null || data === void 0 ? void 0 : (_data$banner7 = data.banner) === null || _data$banner7 === void 0 ? void 0 : (_data$banner7$image = _data$banner7.image) === null || _data$banner7$image === void 0 ? void 0 : _data$banner7$image.classNameWrapper : "bbc-banner-image-country xl:top-28")
          },
          className: "w-full",
          alt: "banner",
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [(data === null || data === void 0 ? void 0 : (_data$dataContent = data.dataContent) === null || _data$dataContent === void 0 ? void 0 : _data$dataContent.firstSection) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-lg font-medium",
          dangerouslySetInnerHTML: {
            __html: data === null || data === void 0 ? void 0 : (_data$dataContent2 = data.dataContent) === null || _data$dataContent2 === void 0 ? void 0 : _data$dataContent2.firstSection
          }
        }), (data === null || data === void 0 ? void 0 : (_data$dataContent3 = data.dataContent) === null || _data$dataContent3 === void 0 ? void 0 : _data$dataContent3.description) && (data === null || data === void 0 ? void 0 : (_data$dataContent4 = data.dataContent) === null || _data$dataContent4 === void 0 ? void 0 : _data$dataContent4.description.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: index === 0 ? "" : "mt-6",
            children: item.text
          }, index);
        })), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pt-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            as: "h3",
            text: "TABLE OF CONTENTS",
            className: "mb-6 text-bbc-30px font-semibold text-bbc-brand-800"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "ml-2",
            children: [data === null || data === void 0 ? void 0 : (_data$dataContent5 = data.dataContent) === null || _data$dataContent5 === void 0 ? void 0 : _data$dataContent5.sectionContent.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative mb-2 pl-3 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  onClick: function onClick(e) {
                    scrollToSection(e, getId(item.title));
                  },
                  href: "#".concat(getId(item.title)),
                  className: "font-medium text-bbc-brand-500 hover:text-[#05D4FE]",
                  children: item.title
                })
              }, index);
            }), (data === null || data === void 0 ? void 0 : (_data$dataContent6 = data.dataContent) === null || _data$dataContent6 === void 0 ? void 0 : _data$dataContent6.contactUs) && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "relative mb-2 pl-3 font-medium  text-bbc-brand-500 before:absolute before:top-2.5 before:left-0 before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                onClick: function onClick(e) {
                  scrollToSection(e, "contact-us");
                },
                href: "#contact-us",
                className: "hover:text-[#05D4FE]",
                children: "Contact Us"
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "page-content",
          children: data === null || data === void 0 ? void 0 : (_data$dataContent7 = data.dataContent) === null || _data$dataContent7 === void 0 ? void 0 : _data$dataContent7.sectionContent.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                id: getId(item.title),
                as: "h3",
                text: "".concat(index + 1, ". ").concat(item.title),
                className: "mb-6 mt-10 text-lg font-semibold text-bbc-brand-700"
              }), (item === null || item === void 0 ? void 0 : item.content) && (item === null || item === void 0 ? void 0 : item.content.map(function (element, i) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [(element === null || element === void 0 ? void 0 : element.subTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                    text: element.subTitle,
                    as: "h4",
                    className: element.className ? element.className : "mt-6 mb-0 pl-0 text-base font-semibold leading-7 tracking-[0.4px] lg:mb-4 lg:pl-4"
                  }), (element === null || element === void 0 ? void 0 : element.text) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(element.className ? element.className : "mb-0 pl-0 lg:mb-6 lg:pl-4"),
                    dangerouslySetInnerHTML: {
                      __html: element.text
                    }
                  }, i), (element === null || element === void 0 ? void 0 : element.subText) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(element.className ? element.className : "mb-6 pl-0 lg:pl-[30px]"),
                    dangerouslySetInnerHTML: {
                      __html: element.subText
                    }
                  }, i), (element === null || element === void 0 ? void 0 : element.subTextChild) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(element.className ? element.className : "mb-6 pl-0 lg:pl-[45px]"),
                    dangerouslySetInnerHTML: {
                      __html: element.subTextChild
                    }
                  }, i)]
                }, i);
              })), (item === null || item === void 0 ? void 0 : item.tabList) && /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
                data: item === null || item === void 0 ? void 0 : item.tabList,
                tabClass: {
                  othersClass: "whitespace-nowrap"
                },
                tabListClass: {
                  display: "flex justify-start",
                  border: "border-0",
                  padding: "px-3",
                  length: "w-full",
                  othersClass: "mb-6 overflow-auto"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                  children: item === null || item === void 0 ? void 0 : item.tabList.map(function (element, i) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                      className: "focus:outline-none focus:outline-0 focus:ring-0",
                      as: "div",
                      children: element === null || element === void 0 ? void 0 : element.content.map(function (e, number) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "mb-6 ml-0 lg:ml-10",
                          dangerouslySetInnerHTML: {
                            __html: e.text
                          }
                        }, number);
                      })
                    }, i);
                  })
                })
              })]
            }, index);
          })
        })]
      })
    }), (_data$dataContent8 = data.dataContent) !== null && _data$dataContent8 !== void 0 && _data$dataContent8.dataContactUs ? /*#__PURE__*/(0,jsx_runtime.jsx)(legal_documents_ContactUsPrivacyPolicy, {
      dataContactUs: (_data$dataContent9 = data.dataContent) === null || _data$dataContent9 === void 0 ? void 0 : _data$dataContent9.dataContactUs
    }) : (data === null || data === void 0 ? void 0 : (_data$dataContent10 = data.dataContent) === null || _data$dataContent10 === void 0 ? void 0 : _data$dataContent10.contactUs) && /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUs/* default */.Z, {
      isRefundPolicy: data === null || data === void 0 ? void 0 : (_data$dataContent11 = data.dataContent) === null || _data$dataContent11 === void 0 ? void 0 : _data$dataContent11.isRefundPolicy
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "top-28 hidden"
    })]
  });
};

/* harmony default export */ var legal_documents = (LegalDocuments);
LegalDocuments.defaultProps = {
  data: {}
};

/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ })

}]);